<template>
  <div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div>
          <!-- <div class="font-weight-bold text-dark font-size-24">IDR {{ totalWeeklySales }}</div> -->
          <div><h5> {{ $t('dashboard.weeklySales') }} </h5></div>
          <vue-chartist class="height-200 ct-hidden-points" type="Line" :data="graphSummary" :options="optionsCart" />
        </div>
      </div>
    </div>
    <div class="row" v-if="!loading">
      <!-- <div class="col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
        <router-link :to="{ path: '/sales/on-process' }" class=" d-flex h-100 w-100">
          <InfoBox :title="$t('dashboard.onProcess')" :content="orderSummary.order_onprocess_qty || 0" color="orange" class="w-100 h-100" />
        </router-link>
      </div> -->
      <!-- <div class="col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
        <router-link :to="{ path: '/sales/cancel-request' }" class="d-flex h-100 w-100">
          <InfoBox :title="$t('dashboard.refundRequest')" :content="orderSummary.order_retourreq_qty || 0" color="red" class="w-100 h-100" />
        </router-link>
      </div> -->
      <div class="col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
        <router-link :to="{ path: '/sales/completed' }" class="d-flex h-100 w-100">
          <InfoBox :title="$t('dashboard.completedOrders')" :content="orderSummary.order_completed_qty || 0" color="primary" class="w-100 h-100" />
        </router-link>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
        <router-link :to="{ path: '/account/ewallet' }" class="d-flex h-100 w-100">
          <InfoBox :title="$t('dashboard.ewallet')" :content="(commission.ewallet || 0) | currency" color="green" class="w-100 h-100" />
        </router-link>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
        <router-link :to="{ path: '/account/list-commission' }" class=" d-flex h-100">
          <InfoBox :title="$t('dashboard.totalCommission')" :content="(commission.commission || 0) | currency" color="indigo" class="w-100 h-100" />
        </router-link>
      </div>
      <div class="col-sm-6 col-lg- mb-33">
        <router-link :to="{ path: '/sales/on-process' }" class="d-block">
          <InfoBox :title="$t('dashboard.onComingCommission')" :content="(commission.commission_will_received || 0) | currency" color="gray" class="w-100 h-100" />
        </router-link>
      </div>
    </div>
    <div v-if="!loading" class="mt-3 mb-3">
      <div class="text-bold" style="font-size: 24px">
        {{ $t('dashboard.bestSeller') }}
      </div>
      <div v-if="!bestSeller.length && !loading" class="d-flex justify-content-center">
        <div class="text-bold" style="font-size: 30px">
          <strong> {{ $t('dashboard.productNotFound') }} </strong>
        </div>
      </div>
      <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 gutter-xs-1 gutter-md-2 gutter-lg-3 mx-n2">
        <div class="col px-2" v-for="(product, index) in bestSeller" :key="index">
          <router-link class="relative d-block bg-white" :to="{ name: 'product.detail', params: { id: product.product_id } }">
            <div class="image">
              <img
                :src="`${product.url}?tr=w-200,h-200,cm-pad_resize,bg-FFFFFF`"
                :alt="product.name"
                class="rounded w-100"
              />
            </div>
            <div class="p-3">
              <div class="text-center pt-1" style="height: 65px;">
                <strong> {{ product.name }} </strong>
              </div>
              <div class="text-center mb-1">
                <div class="text-muted"> Total Donasi: {{ product.qty }} </div>
                <!-- <div class="text-bold"> {{ product.qty }} </div> -->
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <a-tabs v-if="!loading" />
    <div v-if="!loading" class="mt-3">
      <div class="text-bold mb-3" style="font-size: 24px">
        {{ $t('dashboard.lastSoldItems') }}
      </div>
      <div v-if="!lastSoldItems.length && !loading" class="d-flex justify-content-center">
        <div class="text-bold" style="font-size: 30px">
          <strong> {{ $t('dashboard.productNotFound') }}</strong>
        </div>
      </div>
      <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 gutter-xs-1 gutter-md-2 gutter-lg-2 mx-n2">
        <div class="col px-2" v-for="(product, index) in lastSoldItems" :key="index">
          <div class="bg-white mb-4">
            <div class="image">
              <img
                :src="`${product.url}?tr=w-200,h-200,cm-pad_resize,bg-FFFFFF`"
                :alt="product.name"
                class="rounded w-100"
              />
            </div>
            <div class="px-3 py-3">
              <div class="pt-1 text-center" style="height: 65px;">
                <strong> {{ product.name }} </strong>
              </div>
              <div class="text-left mb-1">
                <div class="text-muted"> Donation Number: </div>
                <div class="text-bold"> {{ product.order_number }} </div>
              </div>
              <div class="text-left mb-1">
                <div class="text-muted"> Created at: </div>
                <div class="text-bold"> {{ changeDateFormat(product.created_at) }} </div>
              </div>
              <div class="text-left mb-1">
                <div class="text-muted"> Status: </div>
                <div class="text-bold"> {{ displayText(product.status) }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-tabs v-if="!loading" />
    <div v-if="!loading && mediaKit.length" class="mt-3">
      <MediaKit :mediaKit="mediaKit" />
    </div>
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="fullPage"
        :height="30"
        :width="30"
      />
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import VueChartist from 'v-chartist'
import Loading from 'vue-loading-overlay'
import InfoBox from '@/components/Widget/InfoBox.vue'
import MediaKit from '@/components/MediaKit'

export default {
  components: {
    VueChartist,
    Loading,
    InfoBox,
    MediaKit,
  },
  data() {
    return {
      pagination: {},
      fullPage: true,
      position: {
        x: 0,
        y: 0,
      },
      mediaKit: [],
    }
  },
  created () {
    this.getDashboardData()
    this.getMediaKit()
      .then(data => {
        this.mediaKit = data
      })
  },
  methods: {
    ...mapActions('dashboard', ['getDashboardData', 'getMediaKit']),

    changeDateFormat (value) {
      return moment(value).format('DD MMMM YYYY')
    },
    orderDetail (order_number) {
      this.position.x = window.scrollX
      this.position.y = window.scrollY

      this.$router.push({
        name: 'order.view',
        params: {
          id: order_number,
        },
      })
    },
    displayText(value) {
      const statuses = {
        new: 'Received',
        confirmed: 'Received',
        sent: 'Received',
        delivered: 'Received',
        ready_to_pickup: 'Received',
        packing: 'Received',
        waiting_payment: 'Waiting Payment',
        payment_expired: 'Payment is expired',
        canceled: 'Canceled',
        draft: 'Waiting Payment',
        completed: 'Completed',
        on_process: 'Received',
        on_cancel_req: 'Request for cancellation',
        on_retour_req: 'Request for return',
        payment_unfinish: 'Payment unfinish yet',
        payment_declined: 'Payment declined',
      }

      return Object.prototype.hasOwnProperty.call(statuses, value) ? statuses[value] : value
    },
  },
  computed: {
    ...mapState('dashboard', {
      loading: state => state.loading,
      commission: state => state.commission,
      lastSoldItems: state => state.lastSoldItems,
      orderSummary: state => state.orderSummary,
      graphSummary: state => state.graphSummary,
      optionsCart: state => state.optionsCart,
      bestSeller: state => state.bestSeller,
    }),
    ...mapState(['user']),

    seller_type () {
      return this.user.seller_type
    },
  },
}
</script>

<style scoped>
.image {
  border-bottom: 1px solid #eaeaea;
  /* padding: 1rem; */
  position: relative;
}
</style>
